import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { FavoritesProvider } from "./goourhub/component/FavoritesContext";
import "./App.css";
import "./type-scale.css";
import "./Menu.css";
import "./NewTile.css";
import "./goourhub/main/aligners.css";
import "flag-icons/css/flag-icons.min.css";
import "./goourhub/component/SliderForMobile.jsx";
import AccountBackBar from "./goourhub/component/AccountBackBar"; // adjust path to match the folder
import CommunityPageLayout from "./goourhub/component/CommunityPageLayout";
import AccountGate from "./account/AccountGate";
import SEOManager from "./goourhub/component/SEOManager";
/** Core pages */
import Landing from "./goourhub/component/Landing";
import Hub from "./goourhub/component/Hub";
import HubMart from "./goourhub/component/HubMart.js";
import HubSearchResults from "./goourhub/component/HubSearchResults";

/** General pages */
import ContactUs from "./goourhub/component/ContactUs";
import NeedHelp from "./goourhub/component/NeedHelp";
import PartnerSignup from "./goourhub/component/PartnerSignUp";
import ThankYouPartner from "./goourhub/component/ThankYouPartner";
import FAQPage from "./goourhub/component/FAQ";
import Terms from "./goourhub/component/Terms";
import PrivacyPage from "./goourhub/component/PrivacyPage";
import ZelleConfirmation from "./goourhub/component/ZelleConfirmation";
import ZelleThankYou from "./goourhub/component/ZelleThankYou";
import SocialLandingPage from "./goourhub/component/SocialLandingPage";
import VendorThankYou from "./goourhub/component/VendorThankYou";
import UserThankYou from "./goourhub/component/UserThankYou";
import SignInModal from "./goourhub/component/SignInModal";
import SignUpModal from "./goourhub/component/SignUpModal";
import AboutUs from "./goourhub/component/AboutUs";
import RequestForm from "./goourhub/component/RequestForm";
import Pricing from "./goourhub/component/Pricing";
import FiestaMedalTile from "./goourhub/component/FiestaMedalTile";
import Fiesta from "./goourhub/component/Fiesta";
import PromoSection from "./goourhub/component/PromoSection";
import ProfileHub from "./goourhub/component/ProfileHub";
/** Vendor / profile / special pages */
import PitaPlus from "./goourhub/component/PitaPlus";
import SelamFoodMart from "./goourhub/component/SelamFoodMart";
import AfricanVillage from "./goourhub/component/AfricanVillage";
import VendorTemplate1 from "./goourhub/component/VendorTemplate1";
import VendorTemplate2 from "./goourhub/component/VendorTemplate2";
import VendorTemplate3 from "./goourhub/component/VendorTemplate3";
import VaduAplu from "./goourhub/component/VaduAplu";
import TacoBlvd from "./goourhub/component/TacoBlvd";
import UnGwan from "./goourhub/component/UnGwan";
import RigoPlant from "./goourhub/component/RigoPlant";
import TrinketTrunk from "./goourhub/component/TrinketTrunk";
import IcTroyz from "./goourhub/component/IcToyz";
import TwoBunnies from "./goourhub/component/TwoBunnies";
import G3Production from "./goourhub/component/G3Production";
import JamesWreaths from "./goourhub/component/JamesWreaths";
import AlexSword from "./goourhub/component/AlexSword";
import StarrMurals from "./goourhub/component/StarrMurals";
import NenaClothing from "./goourhub/component/NenaClothing";
import FevenRealtor from "./goourhub/component/FevenRealtor";
import PetersEliteCleaning from "./goourhub/component/PetersEliteCleaning";
import TwoLittleMonkeys from "./goourhub/component/TwoLittleMonkeys";

/** Community / directory pages */
import Mexican from "./goourhub/component/Mexican";
import American from "./goourhub/component/American";
import Turkish from "./goourhub/component/Turkish";
import Syrian from "./goourhub/component/Syrian";
import Lebanese from "./goourhub/component/Lebanese";
import Palestinian from "./goourhub/component/Palestinian";
import African from "./goourhub/component/African";
import Persian from "./goourhub/component/Persian";
import Armenian from "./goourhub/component/Armenian";
import Eritrean from "./goourhub/component/Eritrean";
import Ethiopian from "./goourhub/component/Ethiopian";
import Nigerian from "./goourhub/component/Nigerian";
import MiddleEastern from "./goourhub/component/MiddleEastern";
import Indian from "./goourhub/component/Indian";
import Chinese from "./goourhub/component/Chinese";
import Japanese from "./goourhub/component/Japanese";
import Korean from "./goourhub/component/Korean";
import Thai from "./goourhub/component/Thai";
import European from "./goourhub/component/European";
import Algerian from "./goourhub/component/Algerian";
import Argentinian from "./goourhub/component/Argentinian";
import Australian from "./goourhub/component/Australian";
import British from "./goourhub/component/British";
import Hawaiian from "./goourhub/component/Hawaiian";
import Jamaican from "./goourhub/component/Jamaican";
import Nepali from "./goourhub/component/Nepali";
import Vietnamese from "./goourhub/component/Vietnamese";
import Senegalese from "./goourhub/component/Senegalese";
import Trinidadian from "./goourhub/component/Trinidadian";
import Cameroonian from "./goourhub/component/Cameroonian";

import VisitResturants from "./goourhub/component/VisitResturants";
import VisitGroceries from "./goourhub/component/VisitGroceries";
import VisitFoodTrucks from "./goourhub/component/VisitFoodTrucks";
import VisitKosherPlaces from "./goourhub/component/VisitKosherPlaces";
import VisitVeganPlaces from "./goourhub/component/VisitVeganPlaces";
import FarmersMarket from "./goourhub/component/FarmersMarket";
import FleaMarketPlace from "./goourhub/component/FleaMarketPlace";
import CleaningServices from "./goourhub/component/CleaningServices";
import ITServices from "./goourhub/component/ITServices";
import Realtor from "./goourhub/component/Realtor";
import Photography from "./goourhub/component/Photography";
import Gardening from "./goourhub/component/Gardening";
import Catering from "./goourhub/component/Catering";
import Murals from "./goourhub/component/Murals";
import Wreaths from "./goourhub/component/Wreaths";
import Clothing from "./goourhub/component/Clothing&Footwear";
import Toys from "./goourhub/component/Toys";
import Jewelry from "./goourhub/component/Jewelry";
import ChildCare from "./goourhub/component/ChildCare";
import Electrical from "./goourhub/component/Electrical";
import Plumbing from "./goourhub/component/Plumbing";
import ElderlyCare from "./goourhub/component/ElderlyCare";
import BusinessApprovalDashboard from "./goourhub/component/BusinessApprovalDashboard";
import BusinessCategoryPage from "./goourhub/component/BusinessCategoryPage";
import AllBusinessCategories from "./goourhub/component/AllBusinessCategories";
import BusinessCommunityPage from "./goourhub/component/BusinessCommunityPage";
import ComingSoonDirectory from "./goourhub/component/ComingSoonDirectory";
import BottomTabBar from "./goourhub/component/BottomTabBar";
import ScrollToTop from "./goourhub/component/ScrollToTop";
import PostOffer from "./goourhub/component/PostOffer";
function GoHubApp() {
  return (
     <Router>
  <SEOManager />

  <FavoritesProvider>
        <AccountBackBar />
     
       
<ScrollToTop />
      <Routes>
        {/* Core */}
        <Route path="/" element={<Hub />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/hub" element={<Hub />} />
        <Route path="/HubMart" element={<HubMart />} />
        <Route path="/hub/search" element={<HubSearchResults />} />
        <Route
          path="/business-admin"
          element={<BusinessApprovalDashboard />}
        />
        <Route
  path="/post-offer"
  element={<PostOffer />}
/>

        {/* General pages */}
        <Route
          path="/partner-signup"
          element={
            <AccountGate>
              <PartnerSignup />
            </AccountGate>
          }
        />

        <Route path="/connect" element={<SocialLandingPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/NeedHelp" element={<NeedHelp />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/partner-signup#joinForm" element={<RequestForm />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/FiestaMedalTile" element={<FiestaMedalTile />} />
        <Route path="/Fiesta" element={<Fiesta />} />
        <Route path="/PromoSection" element={<PromoSection />} />

        {/* Auth / thank-you / confirmations */}
        <Route path="/SignInModal" element={<SignInModal />} />
        <Route path="/SignUpModal" element={<SignUpModal />} />
        <Route
          path="/thank-you-partner"
          element={<ThankYouPartner />}
        />
        <Route
          path="/vendor-thankyou"
          element={<VendorThankYou />}
        />
        <Route
          path="/user-thankyou"
          element={<UserThankYou />}
        />
        <Route
          path="/zelle-confirmation"
          element={<ZelleConfirmation />}
        />
        <Route
          path="/zelle-thank-you"
          element={<ZelleThankYou />}
        />

        {/* Vendor / profile / special pages */}
        <Route path="/pitaplus" element={<PitaPlus />} />
        <Route path="/selamfoodmart" element={<SelamFoodMart />} />
        <Route path="/AfricanVillage" element={<AfricanVillage />} />
        <Route
          path="/vendor-template1"
          element={<VendorTemplate1 />}
        />
        <Route
          path="/vendor-template2"
          element={<VendorTemplate2 />}
        />
        <Route
          path="/vendor-template3"
          element={<VendorTemplate3 />}
        />
        <Route path="/vaduaplu" element={<VaduAplu />} />
        <Route path="/tacoblvd" element={<TacoBlvd />} />
        <Route path="/Un-Gwan-Gway" element={<UnGwan />} />
        <Route path="/RigoPlant" element={<RigoPlant />} />
        <Route path="/TrinketTrunk" element={<TrinketTrunk />} />
        <Route path="/IcToyz" element={<IcTroyz />} />
        <Route path="/TwoBunnies" element={<TwoBunnies />} />
        <Route path="/G3Production" element={<G3Production />} />
        <Route path="/JamesWreaths" element={<JamesWreaths />} />
        <Route path="/AlexSword" element={<AlexSword />} />
        <Route path="/StarrMurals" element={<StarrMurals />} />
        <Route path="/NenaClothing" element={<NenaClothing />} />
        <Route path="/FevenRealtor" element={<FevenRealtor />} />
        <Route
          path="/peterselitecleaning"
          element={<PetersEliteCleaning />}
        />
        <Route
          path="/TwoLittleMonkeys"
          element={<TwoLittleMonkeys />}
        />

        {/* Community pages with shared header + collapsible left rail */}
        <Route element={<CommunityPageLayout />}>
          {/* Community guides */}
          <Route
            path="/communities/:communitySlug"
            element={<BusinessCommunityPage />}
          />

          <Route
            path="/categories"
            element={<AllBusinessCategories />}
          />

          <Route
            path="/categories/:categorySlug"
            element={<BusinessCategoryPage />}
          />

          <Route path="/mexican" element={<Mexican />} />
          <Route path="/american" element={<American />} />
          <Route path="/ethiopian" element={<Ethiopian />} />
          <Route path="/eritrean" element={<Eritrean />} />
          <Route path="/african" element={<African />} />
          <Route path="/Turkish" element={<Turkish />} />
          <Route path="/Syrian" element={<Syrian />} />
          <Route path="/Lebanese" element={<Lebanese />} />
          <Route path="/Palestinian" element={<Palestinian />} />
          <Route path="/Persian" element={<Persian />} />
          <Route path="/Armenian" element={<Armenian />} />
          <Route path="/Nigerian" element={<Nigerian />} />
          <Route
            path="/MiddleEastern"
            element={<MiddleEastern />}
          />
          <Route path="/Indian" element={<Indian />} />
          <Route path="/Chinese" element={<Chinese />} />
          <Route path="/Japanese" element={<Japanese />} />
          <Route path="/Korean" element={<Korean />} />
          <Route path="/Thai" element={<Thai />} />
          <Route path="/European" element={<European />} />
          <Route path="/Algerian" element={<Algerian />} />
          <Route path="/Argentinian" element={<Argentinian />} />
          <Route path="/Australian" element={<Australian />} />
          <Route path="/British" element={<British />} />
          <Route path="/Hawaiian" element={<Hawaiian />} />
          <Route path="/Jamaican" element={<Jamaican />} />
          <Route path="/Nepali" element={<Nepali />} />
          <Route path="/vietnamese" element={<Vietnamese />} />
          <Route path="/Senegalese" element={<Senegalese />} />
          <Route
            path="/Trinidadian"
            element={<Trinidadian />}
          />
          <Route
            path="/Cameroonian"
            element={<Cameroonian />}
          />

          <Route
            path="/ComingSoonDirectory"
            element={<ComingSoonDirectory />}
          />

          <Route
            path="/Azerbaijani"
            element={
              <ComingSoonDirectory name="Azerbaijani" />
            }
          />

          {/* Directory pages */}
          <Route
            path="/visitresturants"
            element={
              <BusinessCategoryPage categoryValue="restaurants" />
            }
          />

          <Route
            path="/visitgroceries"
            element={
              <BusinessCategoryPage categoryValue="groceries" />
            }
          />

          <Route
            path="/visitfoodtrucks"
            element={
              <BusinessCategoryPage categoryValue="foodtruck" />
            }
          />

          <Route
            path="/visitkosherplaces"
            element={
              <BusinessCategoryPage categoryValue="kosher" />
            }
          />

          <Route
            path="/visitveganplaces"
            element={
              <BusinessCategoryPage categoryValue="vegan" />
            }
          />

          <Route
            path="/cleaning-services"
            element={
              <BusinessCategoryPage categoryValue="home help" />
            }
          />

          <Route
            path="/itservices"
            element={
              <BusinessCategoryPage categoryValue="it services" />
            }
          />

          <Route
            path="/Realtor"
            element={
              <BusinessCategoryPage categoryValue="realtors" />
            }
          />

          <Route
            path="/Photography"
            element={
              <BusinessCategoryPage categoryValue="photography" />
            }
          />

          <Route
            path="/Gardening"
            element={
              <BusinessCategoryPage categoryValue="gardening" />
            }
          />

          <Route
            path="/Catering"
            element={
              <BusinessCategoryPage categoryValue="catering" />
            }
          />

          <Route
            path="/Jewelry"
            element={
              <BusinessCategoryPage categoryValue="jewelry" />
            }
          />

          <Route
            path="/ChildCare"
            element={
              <BusinessCategoryPage categoryValue="child care" />
            }
          />

          <Route
            path="/Electrical"
            element={
              <BusinessCategoryPage categoryValue="electrical" />
            }
          />

          <Route
            path="/Plumbing"
            element={
              <BusinessCategoryPage categoryValue="plumbing" />
            }
          />

          <Route
            path="/ElderlyCare"
            element={
              <BusinessCategoryPage categoryValue="elderly care" />
            }
          />
        </Route>
<Route path="/profile" element={<ProfileHub />} />
        {/* Fallback */}
        <Route path="*" element={<Hub />} />
      </Routes>

      <BottomTabBar />
      </FavoritesProvider>
    </Router>
  );
}

export default GoHubApp;
